import { Component, Input } from '@angular/core';
import { Step } from '../../models/invoice.model';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent {
  @Input() steps: Step[] = [];
  @Input() currentStep: number = 1;

  get progressWidth(): string {
    return `${((this.currentStep - 1) / (this.steps.length - 1)) * 100}%`;
  }
}